export const WIDGET_KEYS = {
  TOP_10_RECORDS: 'top10Records',
  EMPLOYEES_PROGRESS: 'employeesProgress',
  PERSON_PROGRESS: 'personProgress',
  CHANNEL_PROGRESS: 'channelProgress',
  COMPLIANCE_COURSES_PROGRESS: 'complianceCoursesProgress',
  TRAINING_GROUPS_PROGRESS: 'trainingGroupsProgress',
  LEARNING_PATHS_PROGRESS: 'learningPathsProgress',
  LEARNING_PATHS_PROGRESS_CURRENT: 'learningPathsProgressCurrent',
  COMPETENCY_MATRIX_DATA: 'competencyMatrixData',
  PERSON_COMPETENCY_MATRIX_DATA: 'personCompetencyMatrixData',
  TREND_TO_TARGET_IDD_DATA: 'trendToTargetIddData',
  PENDING_REQUESTS: 'pendingRequests',
  REPORTING: 'reporting',
};